import {
  Text,
} from "@chakra-ui/react";
import { ConfirmDestructiveActionDialog } from "./ConfirmDestructiveActionDialog";
import { WarningTwoIcon } from "@chakra-ui/icons";

interface Props {
  isOpen: boolean;
  onConfirm: (confirmed: boolean) => void;
}

export function ConfirmCloseDirtyDialog({ isOpen, onConfirm }: Props) {
  return (
    <ConfirmDestructiveActionDialog
      icon={<WarningTwoIcon color="yellow.500" mr={2} />}
      isOpen={isOpen}
      onConfirm={onConfirm}
      title="Er zijn onopgeslagen wijzigingen."
    >
      <Text>Weet je zeker dat je je wijzigingen wilt annuleren?</Text>
    </ConfirmDestructiveActionDialog>
  );
}
